import React, { useState } from 'react';

export function WebForm({ title = 'Send os en besked', subtitle = 'Har du spørgsmål eller ønsker du et uforpligtende tilbud? Udfyld formularen, så vender vi hurtigt tilbage.' }) {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '', website_url: '' });
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = ({ target: { name, value } }) => setFormData((current) => ({ ...current, [name]: value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('submitting');
    setErrorMessage('');

    if (formData.website_url) {
      setStatus('success');
      return;
    }

    try {
      const response = await fetch('https://api.dev.auxo.dkwebform/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || 'Der opstod en fejl ved afsendelse af formularen. Prøv venligst igen.');
      }
      setStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '', website_url: '' });
    } catch (error) {
      setErrorMessage(error.message || 'Der kunne ikke oprettes forbindelse til serveren. Tjek din internetforbindelse.');
      setStatus('error');
    }
  };

  const inputClass = 'w-full border border-[#CBD5E1] bg-white px-4 py-3 text-sm text-[#0B0E14] outline-none transition placeholder:text-[#64748B] focus:border-[#206FEA] focus:ring-2 focus:ring-[#206FEA]/15';
  const labelClass = 'mb-2 block text-xs font-semibold uppercase tracking-[0.12em] text-[#0B0E14]';

  return (
    <div className="bg-[#E6EBEF] p-6 shadow-[0_18px_40px_rgba(11,14,20,0.16)] sm:p-8 lg:p-10">
      <div className="mb-7">
        <h2 className="text-3xl font-semibold tracking-tight text-[#0B0E14]">{title}</h2>
        {subtitle && <p className="mt-3 text-sm leading-6 text-slate-600">{subtitle}</p>}
      </div>
      {status === 'success' ? (
        <div className="border border-[#206FEA]/30 bg-white p-7 text-center">
          <i className="fa-light fa-circle-check text-3xl text-[#206FEA]" aria-hidden="true" />
          <h3 className="mt-3 text-xl font-semibold text-[#0B0E14]">Tak for din henvendelse!</h3>
          <p className="mt-2 text-sm leading-6 text-slate-600">Vi har modtaget din besked og vender tilbage hurtigst muligt.</p>
          <button type="button" onClick={() => setStatus('idle')} className="mt-5 rounded-xl text-sm font-semibold text-[#006DDE] hover:underline">Send en ny besked</button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="sr-only absolute -left-[9999px]" aria-hidden="true">
            <label htmlFor="website_url">Website URL (leave blank)</label>
            <input type="text" id="website_url" name="website_url" value={formData.website_url} onChange={handleChange} tabIndex={-1} autoComplete="off" />
          </div>
          <div className="grid gap-5 sm:grid-cols-2">
            <div><label htmlFor="name" className={labelClass}>Navn <span className="text-[#006DDE]">*</span></label><input type="text" id="name" name="name" required placeholder="Dit navn" value={formData.name} onChange={handleChange} className={inputClass} /></div>
            <div><label htmlFor="phone" className={labelClass}>Telefon <span className="text-[#006DDE]">*</span></label><input type="tel" id="phone" name="phone" required placeholder="+45 12 34 56 78" value={formData.phone} onChange={handleChange} className={inputClass} /></div>
          </div>
          <div><label htmlFor="email" className={labelClass}>E-mailadresse <span className="text-[#006DDE]">*</span></label><input type="email" id="email" name="email" required placeholder="navn@eksempel.dk" value={formData.email} onChange={handleChange} className={inputClass} /></div>
          <div><label htmlFor="message" className={labelClass}>Beskrivelse / opgave <span className="text-[#006DDE]">*</span></label><textarea id="message" name="message" required rows={5} placeholder="Beskriv kort din opgave, ønsker eller spørgsmål..." value={formData.message} onChange={handleChange} className={`${inputClass} resize-y`} /></div>
          {status === 'error' && <p role="alert" className="border border-red-200 bg-red-50 p-3 text-sm text-red-700"><i className="fa-light fa-circle-exclamation mr-2" aria-hidden="true" />{errorMessage}</p>}
          <button type="submit" disabled={status === 'submitting'} className="inline-flex w-full items-center justify-center gap-3 rounded-xl bg-[#206FEA] px-6 py-4 text-sm font-semibold text-white transition hover:bg-[#206FEA]/85 disabled:cursor-wait disabled:opacity-60">
            {status === 'submitting' ? <><i className="fa-light fa-spinner fa-spin" aria-hidden="true" />Sender forespørgsel...</> : <>Send forespørgsel <i className="fa-light fa-arrow-right" aria-hidden="true" /></>}
          </button>
        </form>
      )}
    </div>
  );
}
